import axios from "axios";
import { useEffect, useState } from "react";
import { getExpandedGrnReportHome } from "../../store";
import { connect } from "react-redux";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const ChartWithRange = ({
  getExpandedGrnReportHome,
  getExpandedGrnReportHomeReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;

  const [expandedGrnData, setExpandedGrnData] = useState([]);

  useEffect(() => {
    getExpandedGrnReportHome(jwtToken); 
  }, [jwtToken]);

  useEffect(() => {
    let data = getExpandedGrnReportHomeReducer.expandedGrn?.data?.length
      ? getExpandedGrnReportHomeReducer.expandedGrn.data
      : [];

    setExpandedGrnData(data); 
  }, [getExpandedGrnReportHomeReducer]);

  useEffect(() => {
    if (!expandedGrnData.length) return;

    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    Promise.all([
      loadScript("https://cdn.amcharts.com/lib/5/index.js"),
      loadScript("https://cdn.amcharts.com/lib/5/xy.js"),
      loadScript("https://cdn.amcharts.com/lib/5/themes/Animated.js"),
    ])
      .then(() => {
        const am5 = window.am5;
        const am5xy = window.am5xy;
        const am5themes_Animated = window.am5themes_Animated;

        am5.ready(function () {
          const root = am5.Root.new("chartdiv");
          root.setThemes([am5themes_Animated.new(root)]);

          const chart = root.container.children.push(
            am5xy.XYChart.new(root, {
              panX: true,
              panY: true,
              wheelX: "panX",
              wheelY: "zoomX",
              pinchZoomX: true,
              paddingLeft: 0,
            })
          );

          const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
          cursor.lineX.set("forceHidden", true);
          cursor.lineY.set("forceHidden", true);

        
          function formatGrnSeriesData(data, valueKey, dateKey) {
            return data.map((item) => {
              const utcDate = new Date(item[dateKey]);
              const localDate = new Date(
                utcDate.getUTCFullYear(),
                utcDate.getUTCMonth(),
                utcDate.getUTCDate()
              );
              return {
                date: localDate.getTime(),
                value: item[valueKey],
              };
            });
          }

          
          const formattedData = formatGrnSeriesData(
            expandedGrnData,
            "totalGrnCount",
            "grnCd"
          );
          const secondSeriesData = formatGrnSeriesData(
            expandedGrnData,
            "totalPrintedGrn",
            "printedGrnCd"
          );
          const thirdSeriesData = formatGrnSeriesData(
            expandedGrnData,
            "totalPutawayGrn",
            "putawayGrnCd"
          );

          const xAxis = chart.xAxes.push(
            am5xy.DateAxis.new(root, {
              baseInterval: { timeUnit: "day", count: 1 },
              renderer: am5xy.AxisRendererX.new(root, {
                minorGridEnabled: true,
                minGridDistance: 90,
              }),
            })
          );

          const yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
              renderer: am5xy.AxisRendererY.new(root, {}),
            })
          );

          //  First Series - GRN Count (Green)
          const series = chart.series.push(
            am5xy.LineSeries.new(root, {
              name: "GRN Count",
              xAxis,
              yAxis,
              valueYField: "value",
              valueXField: "date",
              stroke: am5.color(0x32cd32),
              tooltip: am5.Tooltip.new(root, {
                labelText: "{valueY}",
              }),
            })
          );
          series.fills.template.setAll({
            fillOpacity: 0.2,
            fill: am5.color(0x32cd32),
            visible: true,
          });
          series.data.setAll(formattedData);
          series.appear(1000);

          //  Second Series - Printed GRN (Red)
          const secondSeries = chart.series.push(
            am5xy.LineSeries.new(root, {
              name: "Printed GRN",
              xAxis,
              yAxis,
              valueYField: "value",
              valueXField: "date",
              stroke: am5.color(0xff0000),
              tooltip: am5.Tooltip.new(root, {
                labelText: "{valueY}",
              }),
            })
          );
          secondSeries.fills.template.setAll({
            fillOpacity: 0.1,
            visible: true,
            fill: am5.color(0xff0000),
          });
          secondSeries.data.setAll(secondSeriesData);
          secondSeries.appear(1000);

          //  Third Series - Putaway GRN (Blue)
          const thirdSeries = chart.series.push(
            am5xy.LineSeries.new(root, {
              name: "Putaway GRN",
              xAxis,
              yAxis,
              valueYField: "value",
              valueXField: "date",
              stroke: am5.color(0x006eff),
              tooltip: am5.Tooltip.new(root, {
                labelText: "{valueY}",
              }),
            })
          );
          thirdSeries.fills.template.setAll({
            fillOpacity: 0.1,
            visible: true,
            fill: am5.color(0x006eff),
          });
          thirdSeries.data.setAll(thirdSeriesData);
          thirdSeries.appear(1000);

          chart.set(
            "scrollbarX",
            am5.Scrollbar.new(root, { orientation: "horizontal" })
          );

          
          const rangeDataItem = yAxis.makeDataItem({});
          yAxis.createAxisRange(rangeDataItem);

          const container = am5.Container.new(root, {
            centerY: am5.p50,
            draggable: true,
            layout: root.horizontalLayout,
          });

          container.adapters.add("x", () => 0);
          container.adapters.add("y", (y) =>
            Math.max(0, Math.min(chart.plotContainer.height(), y))
          );

          container.events.on("dragged", () => updateLabel());

          yAxis.topGridContainer.children.push(container);

          rangeDataItem.set(
            "bullet",
            am5xy.AxisBullet.new(root, { sprite: container })
          );
          rangeDataItem.get("grid").set("visible", false);

          const background = am5.RoundedRectangle.new(root, {
            fill: am5.color(0xffffff),
            fillOpacity: 1,
            strokeOpacity: 0.5,
            cornerRadiusTL: 0,
            cornerRadiusBL: 0,
            cursorOverStyle: "ns-resize",
            stroke: am5.color(0xff0000),
          });
          container.set("background", background);

          const label = container.children.push(
            am5.Label.new(root, {
              paddingTop: 5,
              paddingBottom: 5,
            })
          );

          function updateLabel(value) {
            const y = container.y();
            const position = yAxis.toAxisPosition(
              y / chart.plotContainer.height()
            );
            if (value == null) {
              value = yAxis.positionToValue(position);
            }
          }

          series.events.on("datavalidated", () => {
            const max = yAxis.getPrivate("max", 1);
            const min = yAxis.getPrivate("min", 0);
            const value = min + (max - min) / 2;
            rangeDataItem.set("value", value);
            updateLabel(value);
          });

          chart.appear(1000, 100);
        });
      })
      .catch((err) => {
        console.error("Failed to load amCharts scripts", err);
      });

    return () => {
      const chartDiv = document.getElementById("chartdiv");
      if (chartDiv) chartDiv.innerHTML = "";
    };
  }, [expandedGrnData]);

  return (
    <>
      <style>
        {`
          #chartdiv {
            width: 100%;
            height: 100%;
            max-width: 100%;
          }
        `}
      </style>

      <div id="chartdiv" style={{ width: "100%", height: "100%" }}></div>
    </>
  );
};

// export default ChartWithRange;

const mapStateToProps = (state) => {
  return {
    getExpandedGrnReportHomeReducer: state.getExpandedGrnReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getExpandedGrnReportHome: (jwtToken) =>
      dispatch(getExpandedGrnReportHome(jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartWithRange);
